<template>
    <ModelSelect
        :options="options"
        :value="option"
        :placeholder="placeholder"
        @input="onSelect"
    />
</template>

<script>
    import { ModelSelect } from 'vue-search-select';

    export default {
        name: 'SearchableSelect',
        props: {
            availableOptions: {
                type: Array,
                required: true,
            },
            value: {
                type: Object,
                required: false,
                default: null
            },
            nameField: {
                type: [String, Array],
                required: false,
                default: 'name'
            },
            placeholder: {
                type: String,
                required: false,
                default: ''
            },
        },
        computed: {
            options() {
                return this.availableOptions.map((option) => this.createOption(option));
            },
            option() {
                return this.value ? this.createOption(this.value) : this.createDefaultOption();
            }
        },
        methods: {
            createOption(option) {
                return {
                    value: option,
                    text: this.getText(option),
                };
            },
            getText(option) {
                let result;

                if (typeof this.nameField === 'string') {
                    result = option[this.nameField];
                } else {
                    result = this.nameField.map((name) => option[name]).join(', ');
                }

                return result || '';
            },
            createDefaultOption() {
                return {
                    value: null,
                    text: '',
                };
            },
            onSelect(select) {
                this.$emit('input', select.value);
            }
        },
        components: {
            ModelSelect,
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/components/SearchableSelect.vue